import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchDriverUsersQuery } from '@/features/users'
import { fetchDriverUsersWithPagination } from '@/features/users/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'
import { UsersSearchSchema } from '@/routes/_protected/$tenantKey/settings/drivers/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/drivers/'
)({
  validateSearch: (search) => parse(UsersSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、選択中のDCと enable=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          enable: true
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchDriverUsersQuery(tenantKey, deps)

    return {
      authUser: auth.user,
      users: await fetchDriverUsersWithPagination(query, abortController.signal)
    }
  }
})
